// Simulate network delay
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export async function fetchData<T>(mockData: T): Promise<T> {
  await delay(1000); // Simulate network latency
  return mockData;
}

export async function postData<T>(mockData: T): Promise<T> {
  await delay(800);
  return mockData;
}

export class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
    this.name = 'ApiError';
  }
}